import Moment from "moment"

Moment.locale("pt-BR")

export function convertDateEnToPtBR(value) {
  if (value) return convertDateInFormatToPtBR({ date: value })
  return "Não informado"
}

export function convertDateInFormatToPtBR({ date, format = "YYYY-MM-DD" }) {
  if (date) return Moment(date, format).format("DD/MM/YYYY")
  return "Não informado"
}

export function convertFullDateEnToPtBR(value) {
  if (value) return convertFullDateInFormatToPtBR({ date: value })
  return "Não informado"
}

export function convertFullDateInFormatToPtBR({
  date,
  format = "YYYY-MM-DD HH:mm ZZ"
}) {
  if (date) return Moment(date, format).format("DD/MM/YYYY HH:mm")
  return "Não informado"
}

export function parseDateTime(
  value,
  format = "YYYY-MM-DD HH:mm:ss"
) {
  if (!value) {
    return null
  }

  const parsedDate = Moment(value, format, true)

  if (!parsedDate.isValid()) {
    return null
  }

  return parsedDate
}

export function parseDateTimeToDate(
  value,
  format = "YYYY-MM-DD HH:mm:ss"
) {
  const parsedDate = parseDateTime(value, format)

  return parsedDate ? parsedDate.toDate() : null
}

export default convertDateEnToPtBR
